import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import SmartImg from './SmartImg.jsx';
import { SITE_IMAGES } from '../data/siteImages.js';

function navLinkClass({ isActive }) {
  return isActive ? 'is-active' : undefined;
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        <div className="header-brand">
          <NavLink
            className={({ isActive }) => `logo logo-mark${isActive ? ' is-active' : ''}`}
            to="/"
            end
            onClick={close}
            title="ProScape Outdoor Services — home"
          >
            <span className="logo-crop">
              <SmartImg
                className="logo-photo"
                src={SITE_IMAGES.logo}
                alt=""
                width={200}
                height={200}
              />
            </span>
            <span className="visually-hidden">ProScape home</span>
          </NavLink>
          <NavLink className={({ isActive }) => `nav-home${isActive ? ' is-active' : ''}`} to="/" end onClick={close}>
            Home
          </NavLink>
        </div>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="site-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav
          id="site-nav"
          className={`site-nav${open ? ' is-open' : ''}`}
          aria-label="Primary"
        >
          <NavLink to="/services" className={navLinkClass} onClick={close}>
            Services
          </NavLink>
          <NavLink to="/gallery" className={navLinkClass} onClick={close}>
            Gallery
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) => `nav-cta${isActive ? ' is-active' : ''}`}
            onClick={close}
          >
            Free quote
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
